import Vue from "vue";
import Vuex from "vuex";
import Router from "vue-router";

import store from "./modules/store";
import decoration from "./modules/decoration";
import order from "./modules/order";
//登录页
const LOGIN = () => import("@/view/login/Login.vue");
//主页
const HOME = resolve => require(["../components/Home/Home.vue"], resolve);
//隔断层
const View = resolve => require(["../components/View.vue"], resolve);

//代理管理--代理管理
const MERCHANT = resolve =>
  require(["../components/Merchant/Merchant.vue"], resolve);
//代理管理--代理详情
const MERCHANTDETAIL = resolve =>
  require(["../components/Merchant/MerchantDetail.vue"], resolve);

//子代理企业 管理--企业详情
const ADDSECENTERPRISEDETAIL = resolve =>
  require(["../components/SecEnterPrise/AddSecEnterPriseDetail.vue"], resolve);

//代理管理--(代理管理里的用户管理)
const MERCHANTUSER = resolve =>
  require(["../components/MerchantUser/MerchantUser.vue"], resolve);
//总代Q币管理
const QMANAGE = resolve => require(["../components/QManage/QManage.vue"], resolve);
const qbRecycling = () => import("@/view/qb/admin");

//总代q币日志
const QMANAGELOG = resolve =>
  require(["../components/QManage/QManageLog.vue"], resolve);
//总代级Q币交易记录
const QBUSINESSLOG = resolve =>
  require(["../components/QManage/QBusinessLog.vue"], resolve);
//代理级Q币交易记录
const SECQBUSINESSLOG = resolve =>
  require(["../components/QManage/SecQBusinessLog.vue"], resolve);
//企业级Q币交易记录
const QENTERPRISEBUSINESSLOG = resolve =>
  require(["../components/QManage/QEnterPriseBusinessLog.vue"], resolve);
//企业级Q币日志
const QENTERPRISEMANAGELOG = resolve =>
  require(["../components/QManage/QEnterPriseManageLog.vue"], resolve);
//账号管理-总代的账号管理
const ACCOUNT = resolve =>
  require(["../components/Account/Account.vue"], resolve);
//账号管理-代理的账号管理
const MerchantACCOUNT = resolve =>
  require(["../components/Account/MerchantAccount.vue"], resolve);
//账号管理-子代理的账号管理
const SecMerchantACCOUNT = resolve =>
  require(["../components/Account/SecMerchantAccount.vue"], resolve);
//账号管理-企业的账号管理
const EnterPriseACCOUNT = resolve =>
  require(["../components/Account/EnterPriseAccount.vue"], resolve);

//系统 管理--总代信息统计
const GENERALAGENTTOTALINFO = resolve =>
  require(["../components/System/GeneralAgentTotalInfo.vue"], resolve);
//系统 管理--代理信息统计
const MERCHANTTOTALINFO = resolve =>
  require(["../components/System/MerchantTotalInfo.vue"], resolve);
//系统 管理--企业信息统计
const ENTERPRISETOTALINFO = resolve =>
  require(["../components/System/EnterPriseTotalInfo.vue"], resolve);
//系统 管理--用户操作日志
const TERMINALEVENT = resolve =>
  require(["../components/System/TerminalEvent.vue"], resolve);
//系统 管理-- 终端操作日志
const USEREVENT = resolve =>
  require(["../components/System/UserEvent.vue"], resolve);
//系统 管理--代理操作日志
const MERCHANTEVENT = resolve =>
  require(["../components/System/MerchantEvent.vue"], resolve);
//系统 管理--特殊播报
const BOARDCAST = resolve =>
  require(["../components/System/BoardCast.vue"], resolve);
//系统 管理--企业操作日志
const ENTERPRISEEVENT = resolve =>
  require(["../components/System/EnterPriseEvent.vue"], resolve);
//企业管理
const ENTERPRISEMANAGE = resolve =>
  require(["../components/EnterpriseManage/EnterpriseManage.vue"], resolve);
//子代理--企业管理
//const ADDSECENTERPRISE = resolve => require(['../components/SecEnterPrise/AddSecEnterPrise.vue'], resolve);
const ADDSECENTERPRISE = resolve =>
  require(["../components/SecEnterPrise/AddSecEnterPriseUpdate.vue"], resolve);

//企业管理--详情
const ENTERPRISEDETAIL = resolve =>
  require(["../components/EnterpriseManage/EnterPriseDetail.vue"], resolve);

//企业管理--二级企业管理
const SECENTERPRISE = resolve =>
  require(["../components/SecEnterPrise/SecEnterPrise.vue"], resolve);
//二级企业管理--用户管理
const SECENTERPRISEUSER = resolve =>
  require(["../components/SecEnterPrise/SecEnterPriseUser.vue"], resolve);
//子代理管理--子代理管理
const SECMERCHANTDETAIL = resolve =>
  require(["../components/SecMerchant/SecMerchantDetail.vue"], resolve);
//子代理管理--子代理详情
const SECMERCHANT = resolve =>
  require(["../components/SecMerchant/SecMerchant.vue"], resolve);
//子代理(代理)--Q币管理qassign
const SECQMANAGE = resolve =>
  require(["../components/QManage/SecQManage.vue"], resolve);
//代理对子代理的Q币管理
const SUBAGENTQMANAGE = resolve =>
  require(["../components/QManage/SubAgentQManage.vue"], resolve);
//代理（子代理）  Q币日记
const SECQMANAGELOG = resolve =>
  require(["../components/QManage/SecQManageLog.vue"], resolve);
//Q币管理--Q币分配
const QASSIGN = resolve =>
  require(["../components/QManage/QAssign.vue"], resolve);
//Q币管理--Q币分配
const QRECHARGEVALUE = resolve =>
  require(["../components/QManage/QRechargeValue.vue"], resolve);
//代理管理--总代理操作记录
const GENERALAGENTEVENT = resolve =>
  require(["../components/System/GeneralAgentEvent.vue"], resolve);
//用户管理-用户管理
const USER = resolve => require(["../components/user/User.vue"], resolve);
//用户管理-新增用户
const ADDUSER = resolve => require(["../components/user/AddUser.vue"], resolve);
//用户管理-用户导入导出
const USEREXPORTIMPORTEXCEL = resolve =>
  require(["../components/user/UserExportImportExcel.vue"], resolve);
//用户管理-用户详情
const USERDETAIL = resolve =>
  require(["../components/user/UserDetail.vue"], resolve);
//企业 群组管理--企业 群组管理
const GROUP = resolve => require(["../components/Group/Group.vue"], resolve);
//企业 群组管理--企业 群组管理
const BATCHADDGROUP = resolve =>
  require(["../components/Group/BatchAddGroup.vue"], resolve);
//二级管理 群组管理--二级管理 群组管理
const SECENTERPRISEGROUP = resolve =>
  require(["../components/Group/SecEnterPriseGroup.vue"], resolve);
//企业管理 群组管理 旁听
const GROUPASSIGMENT = resolve =>
  require(["../components/Group/GroupAssignment.vue"], resolve);
//地图管理   百度地图
const USERPOSITION = resolve =>
  require(["../components/Map/BaiDuMap.vue"], resolve);
const USERPOSITIONMAP = resolve =>
  require(["../components/Map/UserMap.vue"], resolve);

//消息管理--终端消息
const TERMINALMESSAGE = resolve =>
  require(["../components/Message/TerminalMessage.vue"], resolve);
//品牌管理--域名管理
const DOMIANNAMEMANAGE = resolve =>
  require(["../components/DomainName/DomainName.vue"], resolve);

//企业 --  档案数据 -- 录音管理
const RECORDINGMANAGE = resolve =>
  require(["../components/FileData/Audio.vue"], resolve);
//数据统计  --  月份数据统计
const MONTHDATATOTAL = resolve =>
  require(["../components/Table/MonthDataTotal.vue"], resolve);
//数据统计  -- 代理查看 终端激活数据统计
const EPACTIVATETOTAL = resolve =>
  require(["../components/Table/EPActivateTotal.vue"], resolve);
//数据统计  -- 企业查看 终端激活数据统计
const EP_EPACTIVATETOTAL = resolve =>
  require(["../components/Table/EP_EPActivateTotal.vue"], resolve);
//数据统计  -- 总代查看 终端激活数据统计
const GA_EPACTIVATETOTAL = resolve =>
  require(["../components/Table/GA_EPActivateTotal.vue"], resolve);
//数据统计  --  年份数据统计
const YEARDATATOTAL = resolve =>
  require(["../components/Table/YearDataTotal.vue"], resolve);
//数据统计  --  月份数据统计
const REPANDPLATOTAL = resolve =>
  require(["../components/Table/RepAndPlaTotal.vue"], resolve);
//会计管理 ---会计管理
const ACCOUNTANT = resolve =>
  require(["../components/Accountant/AccountantManage.vue"], resolve);
//会计管理 ---会计操作记录
const ACCOUNTANTEVENT = resolve =>
  require(["../components/System/AccountantEvent.vue"], resolve);
//错误页面404
const ERROR_404 = resolve => require(["../components/error/404.vue"], resolve);

//菜单管理
const MENU_MANAGEMENT = resolve =>
  require(["../components/System/menuManagement.vue"], resolve);
//
const TASK_MANAGEMENT = resolve =>
  require(["../components/System/Task/MyTaskManage.vue"], resolve);
const DistriButionPassword = resolve =>
  require(["../components/System/DistributionPassword.vue"], resolve);

const SIM_MANAGEMENT = resolve =>
  require(["../components/System/SIMManagement.vue"], resolve);

/**
 * 重构后的路由
 */

const qbLog = () => import("@/view/logger/qb");

const Transfer = () => import("@/view/transfer");


/**
 * 默认首页
 *     * 代理商   1==总代 ,  代理==2, 3=子代理 , 4==企业  ,5== 总代代理管理 ,6==总代信息查询 , 7 ==普通用户 ,8==（代理）信息查询 ,9==(代理)企业管理，
 * 10==子代理信息查询 ，，11== 子代理企业管理  ,,12=企业的信息查询  ，，13==企业的用户管理 ,, 14== 二级企业
 * 15 == 二级企业的信息查询
 */

const HomeIndex = resolve => {
  require(["@/view/homeCount/index.vue"], resolve);
};

Vue.use(Router);
Vue.use(Vuex);

const routes = new Router({
  linkActiveClass: "active",
  routes: [
    {
      path: "/login",
      name: "Login",
      component: LOGIN,
      props: route => ({ platform: route.query.p }),
    },
    {
      path: "/login/:onekey",
      name: "Login",
      component: LOGIN,
      props: true
    },
    {
      path: "/error",
      name: "error",
      component: ERROR_404
    },
    //home
    {
      path: "/home",
      meta: {
        requireAuth: true
      },
      component: HOME,
      name: "home",
      children: [
        {
          path: "/",
          component: HomeIndex
        },
        {
          path: "merchant",
          // 懒加载
          name: "代理管理",
          component: View,
          children: [
            {
              path: "merchantmanage",
              component: () => import("@/view/user/proxy/MGT"),
              // component: MERCHANT,
              name: "代理管理"
            },
            {
              path: "merchantdetail/:id",
              component: MERCHANTDETAIL,
              name: "代理详情"
            },
            {
              path: "merchantuser",
              component: MERCHANTUSER,
              name: "代理里的用户管理"
            }
          ]
        },
        {
          path: "qmanage",
          name: "Q币管理",
          component: View,
          children: [
            {
              path: "qmanage",
              component: QMANAGE,
              name: "总代理Q币管理"
            },
            {
              path: "qbRecycling",
              component: qbRecycling,
              name: "总代QB回收"
            },
            {
              path: "qrechargevalue",
              component: QRECHARGEVALUE,
              name: "总代理Q币充值"
            },
            {
              path: "qmanage/:account",
              component: QMANAGE,
              name: "总代理Q币管理"
            },

            {
              path: "qmanagelog",
              component: qbLog,
              name: "总代理Q币日志"
            },
            {
              path: "qmanagelog/:account",
              component: qbLog,
              name: "总代理Q币日志",
              props: true
            },
            {
              path: "secqmanagelog/:account",
              component: qbLog,
              name: "代理Q币日志",
              props: true
            },
            {
              path: "secqmanagelog",
              component: qbLog,
              name: "代理Q币日志"
            },
            {
              path: "qenterprisemanagelog",
              component: qbLog,
              name: "企业Q币日志"
            },
            {
              path: "qenterprisemanagelog/:account",
              component: qbLog,
              name: "企业Q币日志",
              props: true
            },
            {
              path: "subagentqmanage",
              component: SUBAGENTQMANAGE,
              name: "代理针对子代理的Q币管理"
            },
            {
              path: "secqmanage/:account",
              component: SECQMANAGE,
              name: "代理对企业的Q币管理",
              props: true
            },
            {
              path: "secqmanage",
              component: SECQMANAGE,
              name: "代理对企业的Q币管理"
            },

            {
              path: "qbusinesslog",
              component: QBUSINESSLOG,
              name: "总代级操作交易记录"
            },
            {
              path: "secqbusinesslog",
              component: SECQBUSINESSLOG,
              name: "代理级交易记录"
            },
            {
              path: "merchantevent",
              component: MERCHANTEVENT,
              name: "操作记录"
            },
            {
              path: "qenterprisebusinesslog",
              component: QENTERPRISEBUSINESSLOG,
              name: "企业交易记录"
            },

            {
              path: "qassign",
              component: QASSIGN,
              name: "Q币分配"
            },
            {
              path: "transfer",
              component: Transfer,
              name: "账号转移"
            }

          ]
        },
        {
          path: "secMerchant",
          name: "子代理管理",
          component: View,
          children: [
            {
              path: "secMerchantmanage",
              component: SECMERCHANT,
              name: "子代理管理"
            },

            {
              path: "secenterprisemanage",
              component: ADDSECENTERPRISE,
              name: "子代理--企业管理"
            },

            /*  //自己修改子代理
              {
                path: 'secenterprisemanage',component: ()=> import('@/view/user/secProxy/MGT'),
                // component: ENTERPRISEMANAGE,
                name: '子代理企业管理'
              },
  */

            {
              path: "secmerenterprisedetail/:id",
              component: ADDSECENTERPRISEDETAIL,
              name: "子代理-企业详情"
            },

            {
              path: "secmerchantdetail/:id",
              component: SECMERCHANTDETAIL,
              name: "子代理详情"
            },

            {
              path: "secmerCheckinIccid",
              component: () => import("@/view/iccid/checkinlProxyIccid/secmerProxy"),
              name: "子代理接入iccid"
            },

            {
              path: "secmerOrganization",
              component: () => import("@/view/organization/secmerProxyOrgan"),
              name: "子代理接入iccid"
            },

            {
              path: "secmerSave",
              component: () => import("@/view/iccid/secmerproxy/batchTerminal"),
              // component: USER,
              name: "子代理扫描新增"
            }

          ]
        },

        {
          path: "user",
          name: "用户管理",
          component: View,
          children: [
            {
              path: "usermanage",
              component: () => import("@/view/terminal/MGT/enterprise"),
              // component: USER,
              name: "用户管理"
            },
            // {
            //   path: 'adduser',
            //   component: ADDUSER,
            //   name: '新增用户'
            // },
            {
              path: "exportimportexcel",
              component: () =>
                import("@/view/terminal/MGT/enterprise/batchTerminal"),
              // component:USEREXPORTIMPORTEXCEL,
              name: "用户导出导入"
            },

            {
              path: "imeiimportexcel",
              component: () =>
                import("@/view/terminal/excel/imei/batchIMEI"),
              // component:USEREXPORTIMPORTEXCEL,
              name: "IMEI批量导入"
            },

            {
              path: "lifefreeimportexcel",
              component: () =>
                import("@/view/terminal/excel/lifeFree/batchLifeFree"),
              // component:USEREXPORTIMPORTEXCEL,
              name: "终身免费批量导入"
            },

            {
              path: "userdetail/:id",
              component: () =>
                import("@/view/terminal/MGT/enterprise/UserDetail"),
              // component: USERDETAIL,
              name: "用户详情"
            },
            {
              path: "iccidUser",
              component: () => import("@/view/iccid/allocation/batchTerminal"),
              // component: USER,
              name: "iccid生成用户"
            }

          ]
        },
        {
          path: "group",
          name: "群组管理",
          component: View,
          children: [
            {
              path: "groupmanage",
              component: () => import("@/view/group/MGT"),
              // component: GROUP,
              name: "企业群组管理"
            },
            {
              path: "batchaddgroup",
              component: BATCHADDGROUP,
              name: "批量新增群组"
            },
            {
              path: "assignmentgroup",
              component: GROUPASSIGMENT,
              name: "企业群组指派管理"
            },
            {
              path: "secenterprisegroupmanage",
              component: SECENTERPRISEGROUP,
              name: "二级管理群组管理"
            },

            {
              path: "groupStructure",
              component: () => import("@/view/group/organization"),
              // component: GROUP,
              name: "企业群组管理"
            },

            {
              path: "relevanceGroup",
              component: () => import("@/view/group/relevance/relevanceGroup"),
              // component: GROUP,
              name: "关联群组"
            },

            {
              path: "relevanceGroupList",
              component: () => import("@/view/group/relevance/index"),
              // component: GROUP,
              name: "关联列表"
            }

          ]
        },
        {
          path: "map",
          name: "地图管理",
          component: View,
          children: [
            {
              path: "userposition",
              component: USERPOSITION,
              name: "百度地图--用户定位"
            },
            {
              path: "userpositionmap/:account",
              component: USERPOSITIONMAP,
              name: "百度地图--用户定位"
            }
          ]
        },

        {
          path: "message",
          name: "消息管理",
          component: View,
          children: [
            {
              path: "terminalmessage",
              component: TERMINALMESSAGE,
              name: "消息管理-终端消息"
            }
          ]
        },
        {
          path: "brandmanage",
          name: "品牌管理",
          component: View,
          children: [
            {
              path: "domainnamemanage",
              component: DOMIANNAMEMANAGE,
              name: "品牌管理-域名管理"
            },
            {
              path: "modelmanage",
              component: () => import("@/view/brand/model"),
              name: "品牌管理-机型管理"
            }
          ]
        },

        {
          path: "account",
          name: "账号管理",
          component: View,
          children: [
            {
              path: "accountmanage",
              component: ACCOUNT,
              name: "总代账号管理"
            },
            {
              path: "merchantaccountmanage",
              component: MerchantACCOUNT,
              name: "代理级账号管理"
            },
            {
              path: "enterpriseaccountmanage",
              component: EnterPriseACCOUNT,
              name: "企业级账号管理"
            },
            {
              path: "secmerchantaccountmanage",
              component: SecMerchantACCOUNT,
              name: "子代理级账号管理"
            }
          ]
        },
        {
          path: "terminal",
          name: "终端管理",
          component: View,
          children: [
            {
              path: "terminalmanage",
              component: () => import("@/view/terminal/MGT"),
              name: "终端管理"
            },
            {
              path: "imeiInfo",
              component: () => import("@/view/userpre/index"),
              name: "imei信息"
            },

            {
              path: "agentOrganization",
              component: () => import("@/view/organization/agentOrganization"),
              //  component: () => import("@/view/organization/enterpriseOrganization"),
              name: "代理组织转移"
            },

            {
              path: "enterpriseOrganization",
              //  component: () => import("@/view/organization/agentOrganization"),
              component: () => import("@/view/organization/enterpriseOrganization"),
              name: "企业组织转移"
            },

            {
              path: "terminalMonitor",//终端监听
              //  component: () => import("@/view/organization/agentOrganization"),
              component: () => import("@/view/monitor/index"),
              name: "终端监听"
            },

            {
              path: "queryProxyCheckinData",//代理接入数据
              component: () => import("@/view/iccid/checkinlProxyIccid/index"),
              name: "代理接入数据"
            }


          ]
        },

        {
          path: "enterprise",
          name: "企业管理",
          component: View,
          children: [
            {
              path: "enterprisemanage",
              component: () => import("@/view/user/enterprise/MGT"),
              // component: ENTERPRISEMANAGE,
              name: "企业管理"
            },
            {
              path: "enterprisedetail/:id",
              component: ENTERPRISEDETAIL,
              name: "企业详情"
            },
            {
              path: "zenterprisemanage",
              component: () => import("@/view/user/zenterprise/MGT"),
              name: "企业管理"
            },
            {
              path: "iccidmanage",
              component: () => import("@/view/iccid/enterprise"),
              name: "iccid卡管理"
            },
            {
              path: "checkinIccid",
              component: () => import("@/view/iccid/checkinIccid"),
              name: "接入iccid导出"
            },
            {
              path: "batch",
              component: () => import("@/view/iccid/batch"),
              name: "批量导入"
            }


          ]
        },

        {
          path: "iccid",
          name: "iccid卡管理",
          component: View,
          children: [
            {
              path: "iccidmanage",
              component: () => import("@/view/iccid/admin"),
              name: "iccid卡管理"
            },
            {
              path: "allocation/:id",
              component: () => import("@/view/iccid/allocation/index"),
              name: "iccid卡分配"
            },
            {
              path: "rangeofnew",
              component: () => import("@/view/iccid/ron/index"),
              name: "区间新增"
            }
          ]
        },

        {
          path: "privateNetwork",
          name: "专网管理",
          component: View,
          children: [
            {
              path: "pnIDManage",
              component: () => import("@/view/privatenetwork/index"),
              name: "专网id管理"
            },
            //总代的批量导入，新跳转一个页面
            {
              path: "import",
              component: () => import("@/view/privatenetwork/import/index"),
              name: "专网数据批量导入"
            },

            //企业管理
            {
              path: "entManage",
              component: () => import("@/view/privatenetwork/enterprise/entmanage"),
              name: "企业专网管理"
            },
            //企业批量导入
            {
              path: "entImport",
              component: () => import("@/view/privatenetwork/enterprise/imports/index"),
              name: "企业专网数据批量导入"
            },
            //808轨迹总代管理
            {
              path: "track808",
              component: () => import("@/view/track_808/index"),
              name: "专网808管理"
            },
            //808轨迹企业管理
            {
              path: "entManage808",
              component: () => import("@/view/track_808/enterprise/entmanage"),
              name: "专网808企业管理"
            },

            //808总代的批量导入，新跳转一个页面
            {
              path: "importTrack808",
              component: () => import("@/view/track_808/import/index"),
              name: "808总代批量导入"
            },
            //808企业批量导入
            {
              path: "importEntTrack808",
              component: () => import("@/view/track_808/enterprise/imports/index"),
              name: "808企业批量导入"
            },
          ]
        },

        {
          path: "System",
          name: "simm管理",
          component: View,
          children: [
            {
              path: "SIMManagement",
              component: SIM_MANAGEMENT,
              name: "iccid管理"
            }
          ]
        },

        {
          path: "accountant",
          name: "会计管理",
          component: View,
          children: [
            {
              path: "accountantmanage",
              component: ACCOUNTANT,
              name: "会计管理"
            }
          ]
        },

        {
          path: "secenterprise",
          name: "二级管理",
          component: View,
          children: [
            {
              path: "secenterprise",
              component: SECENTERPRISE,
              name: "二级企业管理"
            },
            /*  {
                path: "usermanage",
                component: SECENTERPRISEUSER,
                name: "二级企业用户管理"
              }*/
            {
              path: "usermanage",
              component: () => import("@/view/terminal/MGT/secondary"),
              // component: USER,
              name: "用户管理"
            },

            {
              path: "organization",
              component: () => import("@/view/organization/index"),
              // component: USER,
              name: "组织结构"
            },

            {
              path: "organizationAuthority",
              component: () => import("@/view/organization/authority/index"),
              // component: USER,
              name: "组织权限数据"
            },

            {
              path: "seconErpriseMonitor",
              component: () => import("@/view/monitor/secenterprise"),
              name: "二级企业监听"
            },


            {
              path: "seconErpriseOrgan",
              component: () => import("@/view/group/organization/seconterprise"),
              name: "二级企业组织管理"
            },

            {
              path: "seconErpriseRelevan",
              component: () => import("@/view/group/relevance/secontRelevanceGroup"),
              name: "二级企业关联群组"
            },

            {
              path: "seconErpriseRelevanList",
              component: () => import("@/view/group/relevance/seconterprise"),
              name: "二级企业关联列表"
            },

            {
              path: "seconOrganization",
              component: () => import("@/view/organization/secontOrganization"),
              name: "二级组织管理"
            },

            //组织权限页面
            {
              path: "authority/:organizationId/:flag/:enterpriseId",
              //  path: "userpositionmap/:account",
              component: () => import("@/view/organization/authority/orgAuthority"),
              name: "权限管理页面"
            },

            //组织移动页面
            {
              path: "mobileWorkers/:id/:flag/:enterpriseId",
              //  path: "userpositionmap/:account",
              component: () => import("@/view/organization/mobile/index"),
              name: "权限转移页面"
            },

          ]
        },

        {
          path: "datatotal",
          name: "数据统计",
          component: View,
          children: [
            {
              path: "monthdatatotal",
              component: MONTHDATATOTAL,
              name: "月份充值数据统计"
            },
            {
              path: "repandplatotal",
              component: REPANDPLATOTAL,
              name: "代理划/回数据统计"
            },
            {
              component: YEARDATATOTAL,
              path: "yeardatatotal",
              name: "年份充值数据统计"
            },
            {
              path: "ep_epactivatetotal",
              component: EP_EPACTIVATETOTAL,
              name: "企业查看-终端激活数据统计"
            },
            {
              path: "ga_epactivatetotal",
              component: GA_EPACTIVATETOTAL,
              name: "总代查看-终端激活数据统计"
            },
            {
              path: "epactivatetotal",
              component: EPACTIVATETOTAL,
              name: "代理查看-终端激活数据统计"
            },

            {
              path: "onlinenumber",
              component: () => import("@/view/homeCount/components/onlineCount"),
              name: "统计1个小时在线数量"
            },

            {
              path: "increaseCount",
              component: () => import("@/view/homeCount/components/userCount"),
              name: "增长数量统计"
            }

          ]
        },

        {
          path: "system",
          name: "系统管理",
          component: View,
          children: [
            {
              path: "boardcast",
              component: () => import("@/view/broadcast"),
              name: "特殊播报"
            },
            {
              path: "SetDistributionPaw",
              component: DistriButionPassword,
              name: "QB分配密码设置"
            },
            {
              path: "generalagenttotalinfo",
              component: HomeIndex, //偷懒了
              name: "总代信息统计"
            },
            {
              path: "menuManagement",
              component: MENU_MANAGEMENT,
              name: "菜单设置 "
            },
            {
              path: "SIMManagement",
              component: SIM_MANAGEMENT,
              name: "SIM卡管理 "
            },
            {
              path: "taskManagement",
              component: TASK_MANAGEMENT,
              name: "任务管理器 "
            },
            {
              path: "merchanttotalinfo",
              component: HomeIndex,
              name: "代理信息统计"
            },
            {
              path: "enterprisetotalinfo",
              component: HomeIndex,
              name: "企业信息统计"
            },
            {
              path: "userevent",
              component: USEREVENT,
              name: "用户操作记录"
            },
            {
              path: "terminalevent",
              component: TERMINALEVENT,
              name: "终端操作记录"
            },
            {
              path: "accountantevent",
              component: ACCOUNTANTEVENT,
              name: "会计操作记录"
            },

            {
              path: "merchantevent",
              //  component: MERCHANTEVENT,
              component: () => import("@/view/logger/operation"),
              name: "代理操作记录"
            },
            // {
            //   path: 'boardcast',
            //   component: BOARDCAST,
            //   name: '特殊播报'
            // },
            {
              path: "enterpriseevent",
              //   component: ENTERPRISEEVENT,
              component: () => import("@/view/logger/operation"),
              name: "企业操作记录"
            },
            {
              path: "generalagentevent",
              component: () => import("@/view/logger/operation"),
              // component: GENERALAGENTEVENT,
              name: "操作记录总代"
            },
            {
              path: "expirationreminder",
              component: () => import("@/view/system/index"),
              // component: GENERALAGENTEVENT,
              name: "到期提醒"
            },
            {
              path: "locationManagement",
              component: () => import("@/view/system/locationManagement"),
              // component: GENERALAGENTEVENT,
              name: "位置管理"
            }
          ]
        },

        {
          path: "filedata",
          name: "档案数据",
          component: View,
          children: [
            {
              path: "recording",
              component: RECORDINGMANAGE,
              name: "录音管理"
            }
          ]
        },

        {
          path: "patrolManage",
          name: "巡更管理",
          component: View,
          children: [
            {
              path: "patrolPoints",
              component: () => import("@/view/patrol/index"),
              name: "巡更管理"
            },
            {
              path: "patrolGroup",
              component: () => import("@/view/patrol/group/index"),
              name: "巡更路线(点分组)"
            },
            {
              path: "patrolPlan",
              component: () => import("@/view/patrol/plan/index"),
              name: "巡更计划"
            },
            {
              path: "patrolPlanGroup",
              component: () => import("@/view/patrol/plan/planGroup"),
              name: "巡更计划"
            },
            {
              path: "patrolPlanUser",
              component: () => import("@/view/patrol/user/index"),//index
              name: "查看用户计划"
            },
            {
              path: "patrolUserPlan",
              component: () => import("@/view/patrol/user/userPlan"),
              name: "设置用户计划"
            },
            //统计
            {
              path: "patrolStatistics",
              component: () => import("@/view/patrol/statistics/index"),
              name: "巡更统计"
            },

            {
              path: "patrolSignCount",
              component: () => import("@/view/patrol/statistics/signCount"),
              name: "签到统计"
            },

            {
              path: "patrolEvent",
              component: () => import("@/view/patrol/event/index"),
              name: "上报事件"
            },

            {
              path: "patrolFile",
              component: () => import("@/view/patrol/file/index"),
              name: "文件管理"
            }
          ]
        },

        {
          path: "taskManage",
          name: "任务管理",
          component: View,
          children: [
            {
              path: "taskManagement",
              component: () => import("@/view/task/index"),
              name: "任务管理"
            },

            {
              path: "taskUser",
              component: () => import("@/view/task/taskUser"),
              name: "任务用户"
            }
          ]
        },

        ,
        order,
        store,
        decoration,
      ]
    }
  ]
});

// if (window.localStorage.getItem("user")) {
//   let user = window.localStorage.getItem("user");
//   store.commit(id, user.id);
// // }
//
// routes.beforeEach((to, from, next) => {
//   //此路线需要授权，请检查是否已登录
//   //如果不是，则重定向到登录页面。
//   if (to.matched.some(r => r.meta.requireAuth)) {
//     if (store.state.id) {
//       next();
//     } else {
//       next("/");
//     }
//   } else {
//     next();
//   }
// });

export default routes;



// WEBPACK FOOTER //
// ./src/router/router.js